<template>
  <div
    v-if="ready && isAllowed('show_car_provisions')"
    class="w-full template"
  >
    <h1>Nicht eingereichte Prämien</h1>

    <div class="flex">
      <label class="pr-4 mt-4">
        Fahrzeugstatus<br>
        <select
          v-model="filters.status"
          multiple
          style="height: 150px;"
        >
          <option value="">- alle -</option>
          <option
            v-for="statusoption in statusoptions"
            :key="statusoption.id"
            :value="statusoption.id"
            v-text="statusoption.title"
          />
        </select>
      </label>

      <label class="pr-4 mt-4">
        Erstzulassung ab<br>
        <input
          v-model="filters.initialRegistrationFrom"
          type="date"
        >
      </label>

      <label class="pr-4 mt-4">
        Erstzulassung bis<br>
        <input
          v-model="filters.initialRegistrationTill"
          type="date"
        >
      </label>

      <label class="pr-4 mt-4">
        Auslieferungsdatum ab<br>
        <input
          v-model="filters.dispatchedFrom"
          type="date"
        >
      </label>

      <label class="pr-4 mt-4">
        Auslieferungsdatum bis<br>
        <input
          v-model="filters.dispatchedTill"
          type="date"
        >
      </label>
    </div>

    <div class="text-lg py-4">
      Gesamtsumme: {{ sum | price }}
    </div>

    <div
      v-if="provisions.length >= 250"
      class="text-orange-mia font-bold"
    >
      Achtung, es werden nur die ältesten 250 Einträge angezeigt und summiert.
    </div>

    <div
      v-if="provisions.length == 0"
      class="text-orange-mia font-bold"
    >
      Es wurden keine passenden Prämienforderungen gefunden
    </div>

    <datatable
      v-if="provisions.length > 0"
      :columns="columns"
      :data="provisions"
      class="datatable sticky table-auto w-full mt-4"
    />
  </div>
</template>

<script>
import sumBy from 'lodash/sumBy'
import PriceColumn from '@/components/ui/datatable/columns/PriceColumn.vue'
import ActionButtonColumn from '@/components/ui/datatable/columns/ActionButtonColumn.vue'

export default {
  data() {
    return {
      ready: false,
      provisions: {},
      filters: {
        status: ['5'],
        initialRegistrationFrom: '',
        initialRegistrationTill: '',
        dispatchedFrom: '',
        dispatchedTill: ''
      },
      statusoptions: [],
      columns: [
        {
          label: 'Angelegt',
          field: 'item_created_item',
          headerAlign: 'left',
          // eslint-disable-next-line camelcase
          representedAs: ({ item_created_item }) => new Date(item_created_item).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })
        },
        {
          label: 'Prämie',
          field: 'item_name',
          headerAlign: 'left',
          representedAs: row => this.getProvisionTitle(row),
          interpolate: true
        },
        {
          label: 'Fahrzeug',
          field: 'item_car',
          headerAlign: 'left',
          representedAs: row => this.getCar(row),
          interpolate: true
        },
        {
          field: 'item_value',
          label: 'Forderung',
          headerAlign: 'right',
          align: 'right',
          component: PriceColumn,
          meta: {
            emptyValue: '0,00 EUR',
            symbol: 'EUR'
          }
        },
        {
          label: '',
          field: '',
          headerAlign: 'left',
          align: 'right',
          component: ActionButtonColumn,
          meta: {
            actions: [
              {
                icon: 'check-circle',
                class: 'border-green-500 text-green-500 hover:bg-green-500',
                onClick: (row) => {
                  this.markApplied(row)
                }
              }
            ]
          }
        }
      ]
    }
  },

  computed: {
    sum() {
      return sumBy(this.provisions, 'item_value')
    }
  },

  watch: {
    filters: {
      handler() {
        this.loadProvisions()
      },
      deep: true
    }
  },

  mounted() {
    if (!this.isAllowed('show_car_provisions')) return

    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/provisions'
        },
        text: 'Prämien verwalten'
      },
      {
        link: {
          path: '/provisions/not-applied'
        },
        text: 'Nicht eingereichte Prämien'
      }
    ])

    this.loadProvisions()
    this.loadStatusoptions()
  },

  methods: {
    loadProvisions() {
      axios.post(`${window.baseUrl}/provisions/getUnappliedProvisions`, this.filters)
        .then(({ data }) => {
          eventBus.$emit('mia-loading-ended')
          this.provisions = data
          this.ready = true
        })
    },

    loadStatusoptions() {
      axios.get(`${window.baseUrl}/car/statusoptions`).then(({ data }) => {
        this.statusoptions = data.statusoptions
      }).catch(() => {
        this.statusoptions = []
      })
    },


    getCar(row) {
      if (row.item_fin != '') {
        return `<a href="/legacy/car_edit/${row.item_car}">${row.item_fin}</a>`
      }

      if (row.item_commission_number != '') {
        return `<a href="/legacy/car_edit/${row.item_car}">${row.item_commission_number}</a>`
      }

      return `<a href="/legacy/car_edit/${row.item_car}">Ohne FIN und ohne Komm</a>`
    },

    getProvisionTitle(row) {
      if (row.item_comment === '') {
        return `<a href="/legacy/provision_edit/${row.id}">${row.item_name}</a>`
      }

      return `<a href="/legacy/provision_edit/${row.id}">${row.item_name}</a><br /><small>Kommentar: ${row.item_comment || ''}</small>`
    },

    markApplied(row) {
      // eslint-disable-next-line no-alert
      if (window.confirm(`Die gewählte Prämienforderung zur Prämie "${row.item_name}" i.H.v. ${row.item_value} wird als "eingereicht" markiert.`)) {
        axios.post(`${window.baseUrl}/provisions/setApplied`, {
          id: row.item_id
        })
          .then(() => {
            this.loadProvisions()
          })
      }
    }
  }
}
</script>
